import React from "react";
import Footer from "../../../components/Footer";

const FinanceInsurance = () => {
  return (
    <section className="bg-white pt-20">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* LEFT CONTENT */}
        <div className="px-6 sm:px-10 lg:px-16 py-12 lg:flex lg:items-center">
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-3">
              Industries →
            </p>

            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Cybersecurity for Finance & Insurance
            </h1>

            <p className="font-semibold text-gray-800 mb-6">
              Financial institutions face relentless cyberattacks due to the
              high value of financial data, personal information, and
              transaction records, with ransomware and account takeover threats
              rising alongside digital banking growth.
            </p>

            <p className="text-gray-600 mb-5 leading-relaxed">
              Sophisticated attacks such as business email compromise, SWIFT
              network exploitation, and API vulnerabilities increasingly target
              banks, insurers, and fintech platforms—often leading to fraud
              losses, service disruptions, and erosion of customer trust.
            </p>

            <p className="text-gray-600 mb-5 leading-relaxed">
              Legacy core systems combined with cloud-native apps, mobile
              banking, and third-party fintech integrations create complex
              environments with potential security blind spots.
            </p>

            <p className="text-gray-600 mb-8 leading-relaxed">
              Financial organizations must also meet strict regulatory and audit
              requirements including PCI DSS, SOX, GLBA, and DORA, making strong
              governance, visibility, and resilience essential.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              How can Synthera help?
            </h3>

            <ul className="space-y-4 mb-8">
              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Zero Trust Identity & Deepfake Defense:</strong> We
                  implement phishing-resistant MFA, behavioral analytics, and
                  identity monitoring to ensure every transaction request is
                  authentic and secure.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Crypto-Agility & Data Longevity:</strong> We help
                  organizations transition toward post-quantum cryptography and
                  future-ready encryption strategies to protect long-term
                  financial data.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Resilience Testing & Compliance Readiness:</strong> We
                  simulate real-world cyber scenarios and third-party outages to
                  strengthen resilience while aligning with regulatory
                  frameworks and audit requirements.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  <strong>Secure Modernization for Legacy Systems:</strong> We
                  apply micro-segmentation, virtual patching, and secure
                  architecture strategies to protect legacy banking and
                  insurance platforms while enabling innovation.
                </p>
              </li>
            </ul>

            <p className="text-gray-700 font-semibold mb-8">
              Our mission is to provide the digital resilience and assurance
              that financial institutions need to innovate with confidence—
              securing today’s transactions and protecting tomorrow’s data.
            </p>

            {/* COOL LINK CTA */}
            <a
              href="/Contact"
              className="group inline-flex items-center gap-1 font-semibold text-green-700 hover:text-green-800 transition"
            >
              <span className="relative">
                Talk to an expert
                <span className="absolute left-0 -bottom-0.5 h-0.5 w-0 bg-green-700 transition-all duration-300 group-hover:w-full"></span>
              </span>
              <span className="transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </a>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="relative hidden lg:block pt-10">
          <img
            src="https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1770613371/Finance_frtarj.png"
            alt="Finance and Insurance Cyber Security"
            className="w-full h-full object-cover"
          />

          {/* GREEN OVERLAY (MATCHED WITH IMAGE OFFSET) */}
          {/* <div className="absolute top-10 left-0 right-0 bottom-0 bg-green-900/70"></div> */}
        </div>
      </div>

      <Footer />
    </section>
  );
};

export default FinanceInsurance;
